<template>
  <v-container class="mt-4 px-5" fluid>

    <v-row v-if="( getdatosUsuarioERPERP.idpuesto == 18 && [568, 7, 161, 382, 626].includes( getdatosUsuarioERPERP.iderp ) ) || getdatosUsuarioERPERP.idpuesto != 18">
      <v-col cols="12" class="tickets-listado">
        <v-card class="shadowCard">
          <v-card-title primary-title class="tickets-toolbar">
            <span class="text-subtitle-1">Tickets</span>
            <v-divider class="mx-4" inset vertical></v-divider>
              <v-radio-group v-model="escuela" row>
                <v-radio label="Todos" :value="0"></v-radio>
                <v-radio label="Fast" :value="2"></v-radio>
                <v-radio label="Inbi" :value="1"></v-radio>
              </v-radio-group>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-checkbox
              v-model="urgente"
              :label="`Urgente`"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportar()"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn 
              class="mr-2" 
              small dark color="primary"
              @click="getReporteTicketsUsuario()"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R. Total
            </v-btn>

            <v-btn
              class="mr-2"
              small dark color="amber darken-3"
              @click="getReporteTicketsMotivo()"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R. Motivos
            </v-btn>

            <v-btn 
              class="mr-2" 
              small dark color="teal accent-3"
              @click="reporteFechas.status = true"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R. Rango Fechas
            </v-btn>

            <v-btn 
              class="mr-2" 
              small dark color="red"
              @click="getReportePorResponsable()"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R RESPONSABLE
            </v-btn>

            <v-tooltip v-if="puedeDesbloqueoEmergencia" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2"
                  icon
                  small
                  :color="estadoFinanzas.desbloqueo_emergencia ? 'grey darken-2' : 'error'"
                  :loading="cargandoEmergencia"
                  v-bind="attrs"
                  v-on="on"
                  @click="toggleDesbloqueoEmergencia"
                >
                  <v-icon small>mdi-lock</v-icon>
                </v-btn>
              </template>
              <span>{{ estadoFinanzas.desbloqueo_emergencia
                ? 'Reactivar bloqueo finanzas'
                : 'Desbloqueo emergencia finanzas' }}</span>
            </v-tooltip>

            <v-btn
              class="mr-2"
              small
              dark
              color="indigo"
              tile
              @click="abrirCatalogoConceptos"
            >
              <v-icon left small>mdi-tag-multiple</v-icon>
              Catálogo
            </v-btn>

            <v-btn
              color="orange"
              dark
              @click="initialize"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-actions>
            <v-row justify="end">
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="usuario"
                  :items="usuariosTickets"
                  label="Selecciona un jefe de área"
                  persistent-hint
                  prepend-inner-icon="mdi-account"
                  hide-details
                  item-text="nombre_completo"
                  item-value="id_usuario"
                  :loading="cargandoJefe"
                >
                </v-autocomplete>
              </v-col>
              
              <v-col cols="12" md="6" lg="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  hide-details
                  v-model="filtroMotivo"
                  :items="opcionesMotivo"
                  item-text="text"
                  item-value="value"
                  label="Motivo"
                  placeholder="Todos"
                  prepend-inner-icon="mdi-tag-outline"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  hide-details
                  v-model="filtroPuesto"
                  :items="opcionesPuesto"
                  item-text="text"
                  item-value="value"
                  label="Puesto"
                  placeholder="Todos"
                  prepend-inner-icon="mdi-badge-account-outline"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  label="Buscar"
                  v-model="search"
                  id="id"
                  hide-details
                  filled
                  dense
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-radio-group
                  v-model="estatusFiltro"
                  row
                  dense
                  hide-details
                  small
                >
                  <v-radio
                    color="blue"
                    label="Asignado"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    color="red"
                    label="Pendiente"
                    :value="3"
                  ></v-radio>
                  <v-radio
                    color="grey"
                    label="Revisión"
                    :value="4"
                  ></v-radio>
                  <v-radio
                    color="green"
                    label="Respondido"
                    :value="5"
                  ></v-radio>
                  <v-radio
                    color="yellow"
                    label="Cerrado"
                    :value="6"
                  ></v-radio>
                  <v-radio
                    color="black"
                    label="Rechazado"
                    :value="7"
                  ></v-radio>
                  <v-radio
                    color="orange"
                    label="Por contestar"
                    :value="9"
                  ></v-radio>
                  <v-radio
                    label="Todos"
                    :value="8"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions class="tickets-tabla-acciones">
            <v-row>
              <v-col cols="12" class="tickets-tabla-scroll">
                <v-data-table
                  :headers="headers"
                  :items="filterTickets"
                  :item-class="itemRowBackground"
                  sort-by="calories"
                  class="elevation-0"
                  :search="search"
                  item-key="name"
                  fixed-header
                  :height="tamanioPantalla"
                  dense
                  multi-sort
                >
                  <template v-slot:item.puesto_usuario="{ item }">
                    {{ textoPuesto(item) }}
                  </template>

                  <template v-slot:item.servicio_requerido="{ item }">
                    <v-chip
                      v-if="item.servicio_requerido"
                      small
                      dark
                      :color="colorServicio(item.servicio_requerido)"
                    >
                      {{ item.servicio_requerido }}
                    </v-chip>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==1"> Abierto </v-chip>
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==2"> Asignado </v-chip>
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==3"> Pendiente </v-chip>
                    <v-chip small color="grey"   dark v-if="item.estatus==4"> Revisión </v-chip>
                    <v-chip small color="green"  dark v-if="item.estatus==5"> Respondido </v-chip>
                    <v-chip small color="yellow"      v-if="item.estatus==6"> Cerrado </v-chip>
                    <v-chip small color="black"  dark v-if="item.estatus==7"> Rechazado </v-chip>
                  </template>

                  <template v-slot:item.id_unidad_negocio="{ item }">
                    <v-chip small v-if="item.id_unidad_negocio==1" color="#2EDAD5"> INBI </v-chip>
                    <v-chip small v-else color="#000D4A" dark> FAST </v-chip>
                  </template>

                  <template v-slot:item.visorrh="{ item }">
                    <v-checkbox small dense hide-details v-model="item.visorrh" @click="updateVisorRh(item)"></v-checkbox>
                  </template>

                  <template v-slot:item.urgenteAdmin="{ item }">
                    <v-checkbox small dense hide-details v-model="item.urgenteAdmin" @click="updateUrgente(item)" v-if="[1,334,954].includes( getdatosUsuarioERPERP.iderp )"></v-checkbox>
                  </template>

                  <template v-slot:item.historial="{ item }">
                    <v-btn
                      v-if="puedeVerHistorial(item)"
                      color="primary"
                      small
                      rounded
                      @click="historialTicket(item)"
                      icon
                    >
                      <v-icon>mdi-file-document</v-icon>
                    </v-btn>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="grey"
                          small
                          rounded
                          icon
                          disabled
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>No tienes permiso para ver el historial</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:item.fecha_entrega="{ item }">
                    <v-chip 
                      v-if="item.fecha_entrega" 
                      small 
                      dark
                      :color="item.diferencia_dias < 0 && item.estatus != 6 ? 'red' : 'grey' "
                    >
                      {{ item.fecha_entrega }}
                    </v-chip>
                  </template>

                  <template v-slot:item.fecha_respuesta_asignado_texto="{ item }">
                    <v-chip
                      v-if="item.fecha_respuesta_asignado_texto !== 'Sin respuesta'"
                      small
                      color="green"
                      dark
                    >
                      {{ item.fecha_respuesta_asignado_texto }}
                    </v-chip>
                    <span v-else>{{ item.fecha_respuesta_asignado_texto }}</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn color="success" small rounded @click="verMotivo(item)" v-if="!item.nombre_jefe">Asignar</v-btn>
                    <v-btn color="orange" dark small rounded @click="verReasignar(item)" v-if="item.nombre_jefe && item.estatus != 6 && item.estatus != 5">Reasignar</v-btn>
                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      rounded
                      small
                    >
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Asignar ticket -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>

              <v-col cols="12">
                <v-textarea outlined v-model="ticket.motivo" label="Motivo de tu ticket" hide-details readonly></v-textarea>
                <v-chip
                  v-if="ticket.servicio_requerido"
                  class="mt-3"
                  small
                  dark
                  :color="colorServicio(ticket.servicio_requerido)"
                >
                  {{ ticket.servicio_requerido }}
                </v-chip>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="areas"
                  v-model="area"
                  label="Selecciona departamento"
                  return-object
                  item-value="iddepartamento"
                  item-text="departamento"
                ></v-autocomplete>

                <v-autocomplete
                  outlined
                  dense
                  :items="puestos"
                  v-model="puesto"
                  label="Selecciona un puesto"
                  return-object
                  item-value="idpuesto"
                  item-text="puesto"
                ></v-autocomplete>

                <v-autocomplete
                  outlined
                  dense
                  :items="jefes"
                  v-model="jefe"
                  label="Selecciona un jefe"
                  return-object
                  item-value="id_usuario"
                  item-text="nombre_completo"
                ></v-autocomplete>

                <v-checkbox 
                  small
                  hide-details 
                  v-model="ticket.visorrh" 
                  @click="updateVisorRh(ticket)"
                  label="Generar copia para RH"
                ></v-checkbox>
                
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" v-if="cargarEvidencias" class="text-center py-4">
                <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
              </v-col>
              <v-col cols="12" md="6" lg="4" v-for="(img, i) in ticket.evidencias" :key="i">
                <v-card class="py-4 shadowCard" @click="verImagen(img.foto, 0)">
                  <EvidenciaMini :src="urlUser + img.foto" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.foto" />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red" dark rounded small @click="abrirRechazar">
            Rechazar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" rounded small dark @click="save">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reasignar ticket -->
    <v-dialog v-model="dialogReasignar" hide-overlay persistent max-width="400">
      <v-card style="position: relative">
        <v-card-title primary-title>
          Reasignar ticket
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogReasignar = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                outlined
                dense
                :items="areas"
                v-model="area"
                label="Selecciona departamento"
                return-object
                item-value="iddepartamento"
                item-text="departamento"
              ></v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="puestosReasignacion"
                v-model="puesto"
                label="Selecciona un puesto"
                return-object
                item-value="idpuesto"
                item-text="puesto"
                :item-disabled="isPuestoBloqueado"
              ></v-autocomplete>

              <v-autocomplete
                outlined
                dense
                :items="jefes"
                v-model="jefe"
                label="Selecciona un jefe"
                return-object
                item-value="id_usuario"
                item-text="nombre_completo"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dialogReasignar = false">Cancelar</v-btn>
          <v-btn color="success" text @click="reasignar()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Historial del ticket -->
    <v-dialog v-model="dialogHistorial" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Historial</span>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            dark
            small
            class="mr-2"
            @click="dialogMensajes = true"
          >
            Ver notas {{ mensajes.length }}
          </v-btn>
          <v-btn fab small text @click="dialogHistorial=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <div>Folio: {{ ticket.idticket }}</div>
          <div v-if="alumnos.length" class="mt-3">
            <p class="ma-0 mb-2"><strong>Alumnos</strong></p>
            <v-data-table
              :headers="headersAlumnos"
              :items="alumnos"
              class="elevation-0 mb-4"
              dense
              hide-default-footer
              :mobile-breakpoint="100"
            ></v-data-table>
          </div>
          <v-container v-for="(respuestas, i) in historial" :key="i">
            <v-row justify="space-between">
              <v-col cols="4" class="pa-2">
                <p class="ma-0"><strong>Motivo del ticket</strong></p>
              </v-col>
              <v-col cols="4" class="pa-2 d-flex justify-center">
                <div v-if="respuestas.estatus==1" >RESPONDIDO</div>
                <div v-else>SIN RESPONDER</div><br/>
              </v-col>
              <v-col cols="4" class="d-flex justify-end pa-2">
                <p class="ma-0">{{ respuestas.fecha }}</p>
              </v-col>
            </v-row>
            <v-row  class="mt-0">
              <v-col cols="8" class="pa-2">
                <p class="pa-2 mb-0 mensajeIzq">
                  {{ respuestas.motivo }}
                  <br>
                  <span style="font-size: small;">{{ respuestas.fecha }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col cols="2" v-for="(img, i) in respuestas.evidencias" :key="i">
                <v-card class="py-4 shadowCard" @click="verImagen( img.foto, img.es_solucion )">
                  <EvidenciaMini
                    :src="(ticket.tipousuario ? (ticket.id_unidad_negocio==1 ? urlINBI : urlFAST) : ticket.movil ? (ticket.id_unidad_negocio==1 ? urlINBI : urlFAST) : url) + img.foto"
                    :video="!!img.video"
                    :pdf="!!img.pdf"
                    :nombre="img.foto"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row justify="end" class="mt-0" v-if="respuestas.respuesta">
              <v-col cols="6" class="d-flex justify-end pa-2">
              <p class="ma-0" >Respondió: <strong> {{ respuestas.jefe }} </strong> </p>
              </v-col>
            </v-row>
            <v-row justify="end" class="mt-0" v-if="respuestas.respuesta">
              <v-col cols="8" class="pa-2">
                <p class="pa-2 text-end mensajeDer">
                  {{ respuestas.respuesta }}
                  <br>
                  <span style="font-size: small;" >{{ respuestas.fecharespuesta }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col cols="2" v-for="(img, i) in respuestas.evidenciasRespuesta" :key="i">
                <v-card class="py-4 shadowCard" @click=" verImagen( img.foto, img.es_solucion )">
                  <EvidenciaMini :src="url + img.foto" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.foto" />
                </v-card>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- <v-row>

              <v-col cols="12" v-for="(respuestas, i) in historial" :key="i">
                <div>Folio: {{ ticket.idticket }}</div>
                <div>Fecha: {{ respuestas.fecha }}</div>
                <div v-if="respuestas.estatus==1">RESPONDIDO</div>
                <div v-else>SIN RESPONDER</div><br/>
                <v-textarea rows="3" auto-grow outlined v-model="respuestas.motivo" label="Motivo de tu ticket" readonly></v-textarea>-->

                <!-- chip para el nombre del que lo contesto -->
                <!--<v-chip small dense hide-details>
                  Respondió: <strong> {{ respuestas.jefe }} </strong> 
                </v-chip>

                <v-textarea 
                  class="mt-3"
                  rows="3" 
                  auto-grow
                  outlined 
                  v-model="respuestas.respuesta" 
                  label="Solución" 
                  v-if="ver==false" 
                  readonly
                ></v-textarea>

                <v-row>
                  <v-col cols="12" md="6" lg="4" v-for="(img, i) in respuestas.evidencias" :key="i">
                    <v-card class="py-4 shadowCard">
                      <v-img :src="url + img.foto" contain aspect-ratio="2"></v-img>
                    </v-card>
                  </v-col>
                </v-row>

              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogHistorial=false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMensajes" max-width="800px">
      <v-card>
        <v-card-title>
          Notas
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogMensajes = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="!mensajes.length" class="grey--text">Este ticket no tiene notas.</div>
          <span v-for="(mensaje, i) in mensajes" :key="i">
            <v-row v-if="mensaje.id_usuario != getdatosUsuarioERPERP.iderp">
              <v-col cols="12">
                <v-card class="ml-6 pa-3 mt-2" max-width="400" color="#f2f2f2" style="border-radius: 15px; border-top-left-radius: 0">
                  <div class="text-subtitle-1">{{ mensaje.nota }}</div>
                  <v-card-actions class="pa-0">
                    <div class="text-caption blue--text">{{ mensaje.nombre_completo }}</div>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="mensaje.id_usuario == getdatosUsuarioERPERP.iderp">
              <v-col cols="12" align="right">
                <v-card class="mr-6 mt-2 pa-3" max-width="400" dark color="#0465ac" style="border-radius: 15px; border-top-right-radius: 0;">
                  <div class="text-subtitle-1">{{ mensaje.nota }}</div>
                </v-card>
              </v-col>
            </v-row>
          </span>
        </v-card-text>
        <v-card-text class="pb-0 pt-6">
          <v-text-field
            v-model="mensajeRechazo"
            :append-outer-icon="mensajeRechazo ? 'mdi-send' : ''"
            outlined
            clearable
            label="Nota"
            type="text"
            hide-details
            dense
            @click:append-outer="enviarMensaje()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dialogMensajes = false">Cerrar</v-btn>
          <v-btn color="success" text @click="enviarMensaje()">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para responder -->
    <v-dialog v-model="dialogResponder" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Responder Ticket</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogResponder=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text v-for="(respuestas, i) in historial" :key="i">
          <div>
            Folio: {{ ticket.idticket }}
            <v-chip
              v-if="ticket.servicio_requerido"
              class="ml-2"
              small
              dark
              :color="colorServicio(ticket.servicio_requerido)"
            >
              {{ ticket.servicio_requerido }}
            </v-chip>
          </div>
          <v-row justify="space-between">
              <v-col cols="4" class="pa-2">
                <p class="ma-0"><strong>Motivo del ticket</strong></p>
              </v-col>
              <v-col cols="4" class="pa-2 d-flex justify-center">
                <div v-if="respuestas.estatus==1" >RESPONDIDO</div>
                <div v-else>SIN RESPONDER</div><br/>
              </v-col>
              <v-col cols="4" class="d-flex justify-end pa-2">
                <p class="ma-0">{{ respuestas.fecha }}</p>
              </v-col>
            </v-row>
            <v-row  class="mt-0">
              <v-col cols="8" class="pa-2">
                <p class="pa-2 mb-0 mensajeIzq">
                  {{ respuestas.motivo }}
                  <br>
                  <span style="font-size: small;">{{ respuestas.fecha }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col cols="2" v-for="(img, i) in respuestas.evidencias" :key="i">
                <v-card class="py-4 shadowCard" @click="verImagen( img.foto, img.es_solucion )">
                  <EvidenciaMini
                    :src="(ticket.tipousuario ? (ticket.id_unidad_negocio==1 ? urlINBI : urlFAST) : ticket.movil ? (ticket.id_unidad_negocio==1 ? urlINBI : urlFAST) : url) + img.foto"
                    :video="!!img.video"
                    :pdf="!!img.pdf"
                    :nombre="img.foto"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row justify="end" class="mt-0" v-if="respuestas.respuesta">
              <v-col cols="8" class="pa-2">
                <p class="pa-2 text-end mensajeDer">
                  {{ respuestas.respuesta }}
                  <br>
                  <span style="font-size: small;" >{{ respuestas.fecharespuesta }}</span>
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col cols="2" v-for="(img, i) in respuestas.evidenciasRespuesta" :key="i">
                <v-card class="py-4 shadowCard" @click="verImagen( img.foto, img.es_solucion )">
                  <EvidenciaMini :src="url + img.foto" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.foto" />
                </v-card>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            
          <!-- <div>Folio: {{ ticket.idticket }}</div>
          <div>Fecha: {{ respuestas.fecha }}</div>
          <div v-if="respuestas.estatus==1">RESPONDIDO</div>
          <div v-else>SIN RESPONDER</div><br/>
          <v-textarea rows="3" outlined v-model="respuestas.motivo" label="Motivo de tu ticket" readonly></v-textarea> -->
          <v-textarea v-if="respuestas.estatus==0" rows="3" outlined v-model="respuesta" label="Solución"></v-textarea>

          <v-file-input
              v-if="respuestas.estatus==0"
              small-chips
              multiple
              filled
              dense
              single-line
              v-model="files"
              accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*, application/pdf, .pdf"
              placeholder="Imágenes, videos o PDF"
              prepend-icon="mdi-camera"
              label="Evidencias"
              @change="cargarFotos()"
            ></v-file-input>

            <v-row class="mb-4" v-if="respuestas.estatus==0">
              <v-col cols="2" v-for="(img, i) in vistaPrevias" :key="i">
                <v-card class="py-4 shadowCard">
                  <EvidenciaMini :src="img.url" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.image_name" />
                  <v-btn color="error" x-small @click="eliminarFoto(img.url)" top right absolute fab>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              dark
              small
              rounded
              @click="dialogResponder=false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              rounded
              @click="saveRespuesta(respuestas)"
              v-if="ver==false"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>


    <!-- Dialogo para responder -->
    <v-dialog v-model="dialogReporte" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ reporteModo === 'motivo' ? 'Reporte de motivos' : 'Reporte de Tickets' }}</span>

          <v-spacer></v-spacer>
          <v-btn 
            class="mr-2" 
            small dark color="green"
            @click="exportExcel( reporte, reporteModo === 'motivo' ? 'reporte_motivos' : 'reporte_tickets')"
            tile
          >
            <v-icon small>mdi-microsoft-excel</v-icon>
          </v-btn>
          <v-btn fab small text @click="dialogReporte=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>



        <v-card-text >

          <v-row>
            <v-col cols="12">
              Tickets sin atender = Asignados + Revisión<br/>
              Total de tickets abiertos = Asignados + Pendientes + Revisión + Rechazados
            </v-col> 

            <v-col cols="12">
              % Tickets Asignados: 100 - (  Tickets sin atender / Total de tickets abiertos  ) * 100
            </v-col> 

          </v-row>
          

          <v-data-table
            :headers="headersReporteActivo"
            :items="reporte"
            class="elevation-0"
            dense
            multi-sort
          >
            <template v-slot:item.Bloqueado="{ item }">
              <v-chip
                small
                :color="item.Bloqueado == 1 ? 'red' : 'green' "
                dark
              >
                {{ item.Bloqueado == 1 ? 'Bloqueado' : 'Liberado' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogReporte=false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para responder -->
    <v-dialog v-model="dialogResponsable" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Reporte de Tickets</span>

          <v-spacer></v-spacer>
          <v-btn 
            class="mr-2" 
            small dark color="green"
            @click="exportExcel( reporte, 'reporte_tickets')"
            tile
          >
            <v-icon small>mdi-microsoft-excel</v-icon>
          </v-btn>
          <v-btn fab small text @click="dialogResponsable=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text >
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                label="Responsable"
                :items="reporte"
                v-model="responsable"
                item-value="nombre_completo"
                item-text="nombre_completo"
                filled
                denses
              ></v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersResponsable"
            :items="ticketsPorResponsable"
            class="elevation-0"
            dense
            multi-sort
          ></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="dialogResponsable=false"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Visualizar imagenes -->
    <Imagen @close="closeImagen" :respuestaImagen="es_solucion" :isOpen="dialogImagen" :imagen="imagen" :ticket="ticket"/>

    <ticketFecha
      v-if="reporteFechas.status"
      :reporteFechas="reporteFechas"  
    />

    <v-dialog v-model="dialogCatalogoConceptos" max-width="1100" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Catálogo de motivos
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogCatalogoConceptos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="mb-3">
            Elige las etiquetas repetidas y la que se conserva. Los tickets pasan a esa etiqueta.
          </p>
          <v-select
            :items="conceptosSeleccionados"
            v-model="conceptoDestino"
            item-text="etiqueta"
            item-value="id"
            label="Etiqueta que se conserva"
            filled
            dense
            hide-details
            class="mb-4"
          ></v-select>
          <v-data-table
            v-model="conceptosSeleccionados"
            :headers="headersCatalogo"
            :items="conceptosCatalogo"
            item-key="id"
            show-select
            dense
            elevation="0"
            :loading="cargandoCatalogo"
            no-data-text="Todavía no hay etiquetas"
          >
            <template v-slot:item.departamento="{ item }">
              {{ nombreDepartamento(item.iddepartamento) }}
            </template>
            <template v-slot:item.instruccion="{ item }">
              <span>{{ recortarInstruccion(item.instruccion) }}</span>
            </template>
            <template v-slot:item.editar="{ item }">
              <v-btn icon small @click="editarConcepto(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small tile text @click="dialogCatalogoConceptos = false">Cerrar</v-btn>
          <v-btn
            small
            tile
            color="primary"
            :loading="fusionandoCatalogo"
            :disabled="fusionandoCatalogo"
            @click="fusionarConceptos"
          >
            Fusionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarConcepto" max-width="640" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ conceptoEdicion.etiqueta }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogEditarConcepto = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            :items="departamentosCatalogo"
            v-model="conceptoEdicion.iddepartamento"
            item-text="departamento"
            item-value="iddepartamento"
            label="Departamento"
            filled
            dense
            hide-details
            class="mb-4"
          ></v-autocomplete>
          <v-textarea
            v-model="conceptoEdicion.instruccion"
            label="Instrucción para la revisión"
            filled
            dense
            hide-details
            rows="4"
            auto-grow
          ></v-textarea>
          <p class="mt-3 mb-0 grey--text text--darken-1">
            Si el ticket no cumple esta instrucción, no se guarda y se le pide el dato al usuario.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small tile text @click="dialogEditarConcepto = false">Cerrar</v-btn>
          <v-btn
            small
            tile
            color="primary"
            :loading="guardandoConcepto"
            :disabled="guardandoConcepto"
            @click="guardarConcepto"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';

  import { mapGetters } from 'vuex'
  var moment = require('moment');
  moment.locale(); 
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import validarErrores  from '@/mixins/validarErrores'
  import {
    puedeDesbloqueoEmergenciaFinanzas,
  } from '@/utils/bloqueoValidacionFinanzas'
  
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import Imagen                from '@/components/tickets/Imagen.vue'
  import EvidenciaMini         from '@/components/tickets/EvidenciaMini.vue'
  import { clasificarArchivoEvidencia } from '@/utils/ticketEvidencias'
  import ticketFecha           from '@/components/tickets/ticketFecha.vue'

  export default {
    components:{
      Alerta,
      carga,
      Imagen,
      EvidenciaMini,
      ticketFecha
    },

    mixins: [ funcionesExcel, validarErrores ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialogRechazo:false,
      motivoRechazo:'',

      longitud:10,
      search:'',
      respuesta:'',
      ver:false,
      dialogResponder: false,
      firstHistorial: {},
      lastHistorial: {},
      historial:{},
      alumnos: [],
      headersAlumnos: [
        { text: 'Matrícula', value: 'matricula' },
        { text: 'Alumno', value: 'alumno' },
        { text: 'Grupo', value: 'grupo' },
      ],
      dialogHistorial:false,
      dialogMensajes: false,
      mensajes: [],
      mensajeRechazo: '',
      filtroPuesto: null,
      ticket:{},

      areas:[],
      area: null,

      puestos:[],
      puesto:null,

      jefes:[],
      jefe: null,

      dialog: false,
      dialogReasignar: false,
      dialogReporte: false,
      reporteModo: 'usuario',
      reporte: [],
      headersReporte: [
        { text: 'idjefe_area'    , value: 'idjefe_area',       },
        { text: 'Nombre'         , value: 'nombre_completo'    },
        { text: 'Asignados'      , value: 'Asignados'          },
        { text: 'Pendiente'      , value: 'Pendiente'          },
        { text: 'Revisión'       , value: 'Revisión'           },
        { text: 'Respondido'     , value: 'Respondido'         },
        { text: 'Cerrados'       , value: 'Cerrados'           },
        { text: 'Rechazados'     , value: 'Rechazados'         },
        { text: 'Por contestar'  , value: 'Total_contestar'    },
        { text: '% Atención'     , value: 'porcentajeAtencion' },
        { text: 'Total'          , value: 'Total'              },
        { text: 'Bloqueado'      , value: 'Bloqueado'          },
      ],
      headersReporteMotivo: [
        { text: 'Motivo'         , value: 'motivo'             },
        { text: 'Asignados'      , value: 'Asignados'          },
        { text: 'Pendiente'      , value: 'Pendiente'          },
        { text: 'Revisión'       , value: 'Revisión'           },
        { text: 'Respondido'     , value: 'Respondido'         },
        { text: 'Cerrados'       , value: 'Cerrados'           },
        { text: 'Rechazados'     , value: 'Rechazados'         },
        { text: 'Por contestar'  , value: 'Total_contestar'    },
        { text: '% Atención'     , value: 'porcentajeAtencion' },
        { text: 'Total'          , value: 'Total'              },
      ],


      headers: [
        { text: 'Folio',             value: 'idticket', },
        { text: 'Usuario',           value: 'nombre_completo' },
        { text: 'Puesto',            value: 'puesto_usuario' },
        { text: 'Escuela',           value: 'id_unidad_negocio' },
        { text: 'Sucursal',          value: 'plantel' },
        { text: 'Fecha de creación', value: 'fecha_apertura' },
        //{ text: 'F. entrega'       , value: 'fecha_entrega'     },
        { text: 'F. respuesta asignado', value: 'fecha_respuesta_asignado_texto' },
        { text: 'Resuelto en:',      value: 'fecha_asignacion' },
        { text: 'Estatus',           value: 'estatus' },
        { text: 'Area',              value: 'area' },
        { text: 'Encargado',         value: 'nombre_jefe' },
        { text: 'Auxiliar',          value: 'nombre_auxiliar' },
        { text: 'Motivo',            value: 'motivo_concepto' },
        { text: 'Servicio requerido', value: 'servicio_requerido' },
        //{ text: 'Visor RH',          value: 'visorrh'},
        { text: 'Urgente',           value: 'urgenteAdmin'},
        { text: 'Actions',           value: 'actions', sortable: false },
        { text: 'Historial',         value: 'historial', sortable: false },
      ],
      tickets: [],
      estatusFiltro:8,
      usuariosTickets:[],
      usuario: null,
      cargandoJefe: false,
      url:'', //url del servidor
      urlUser:'', //puede ser url de alumnos
      escuela:0,
      urgente:0,

      dialogResponsable: false,
      responsable: null,
      headersResponsable: [
        { text: 'Nombre'         , value: 'nombre_completo' },
        { text: 'Asignados'      , value: 'Asignados' },
      ],
      vistaPrevias: [],
      fotos:[],
      files: [],
      dialogImagen:false,
      cargarEvidencias: false,
      es_solucion: false,
      url:'',
      urlINBI:'',
      urlFAST:'',
      imagen:'',
      reporteFechas:{
        status: false,
      },
      cargandoEmergencia: false,
      estadoFinanzas: {
        pendientes: 0,
        desbloqueo_emergencia: false,
        bloqueado: false,
      },

      filtroMotivo: '__todos__',
      dialogCatalogoConceptos: false,
      conceptosCatalogo: [],
      conceptosSeleccionados: [],
      conceptoDestino: null,
      cargandoCatalogo: false,
      fusionandoCatalogo: false,
      departamentosCatalogo: [],
      dialogEditarConcepto: false,
      guardandoConcepto: false,
      conceptoEdicion: {
        id: null,
        etiqueta: '',
        iddepartamento: null,
        instruccion: '',
      },
      headersCatalogo: [
        { text: 'Etiqueta', value: 'etiqueta' },
        { text: 'Departamento', value: 'departamento' },
        { text: 'Instrucción', value: 'instruccion' },
        { text: 'Tickets', value: 'tickets', align: 'end' },
        { text: '', value: 'editar', sortable: false, width: 60 },
      ],
    }),

    computed: {

      ...mapGetters('login',['getdatosUsuarioERPERP','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos']),

      puedeDesbloqueoEmergencia () {
        return puedeDesbloqueoEmergenciaFinanzas(
          this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
        )
      },

      headersReporteActivo () {
        return this.reporteModo === 'motivo' ? this.headersReporteMotivo : this.headersReporte
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ticket' : 'Asignar Ticket'
      },

      puedeSeleccionarAuxiliarRH () {
        return Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) === 966
      },

      puestosReasignacion () {
        return this.filtrarPuestosPermitidos(this.puestos)
      },

      tamanioPantalla () {
        return this.$vuetify.breakpoint.height - 350
      },

      opcionesMotivo () {
        const conteo = {}
        const tickets = this.tickets || []
        let sinEtiqueta = 0
        let sinClasificar = 0
        let total = 0
        for (let i = 0; i < tickets.length; i++) {
          const ticket = tickets[i]
          if ([2, 3, 4, 7].indexOf(Number(ticket.estatus)) === -1) continue
          if (this.escuela && ticket.id_unidad_negocio != this.escuela) continue
          if (this.urgente && ticket.urgenteAdmin != this.urgente) continue
          total++
          if (Number(ticket.sin_clasificar) === 1) sinClasificar++
          const etiqueta = this.motivoAgrupado(ticket.motivo_concepto)
          if (!etiqueta) {
            sinEtiqueta++
            continue
          }
          conteo[etiqueta] = (conteo[etiqueta] || 0) + 1
        }
        const opciones = [{ text: 'Todos (' + total + ')', value: '__todos__' }]
        if (sinEtiqueta) {
          opciones.push({ text: 'Sin etiqueta (' + sinEtiqueta + ')', value: '__sin__', cantidad: sinEtiqueta })
        }
        if (sinClasificar) {
          opciones.push({ text: 'Sin clasificar (' + sinClasificar + ')', value: '__sin_clasificar__', cantidad: sinClasificar })
        }
        const etiquetas = Object.keys(conteo)
        for (let i = 0; i < etiquetas.length; i++) {
          opciones.push({
            text: etiquetas[i] + ' (' + conteo[etiquetas[i]] + ')',
            value: etiquetas[i],
            cantidad: conteo[etiquetas[i]]
          })
        }
        const todos = opciones[0]
        const resto = opciones.slice(1).sort(function (a, b) {
          if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad
          return String(a.value).localeCompare(String(b.value), 'es')
        })
        return [todos].concat(resto)
      },

      opcionesPuesto () {
        const conteo = {}
        const tickets = this.tickets || []
        for (let i = 0; i < tickets.length; i++) {
          const puesto = this.textoPuesto(tickets[i]) || 'Sin puesto'
          conteo[puesto] = (conteo[puesto] || 0) + 1
        }
        const opciones = [{ text: 'Todos', value: null }]
        const nombres = Object.keys(conteo).sort(function (a, b) {
          return a.localeCompare(b, 'es')
        })
        for (let i = 0; i < nombres.length; i++) {
          opciones.push({
            text: nombres[i] + ' (' + conteo[nombres[i]] + ')',
            value: nombres[i],
          })
        }
        return opciones
      },
      
      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          if(element.size > 26214400){ //26214400 = 25MB
            this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
          } else {
              this.getBase64(element, formData)
          }
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
        const tipoArchivo = clasificarArchivoEvidencia(file.name)
        me.vistaPrevias.push({
                url: reader.result, 
                formData: formData, 
                image_name: file.name,
                video : tipoArchivo.video,
                pdf: tipoArchivo.pdf,
                file
            })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },


      filterTickets () {
        const tickets = this.tickets
        if(tickets){
          let newtickets = this.tickets;
          // El filtro de jefe (usuario) ya consulta al back por idjefe_area;
          // aquí solo aplicamos estatus / escuela / urgente sobre lo cargado.
          if (this.estatusFiltro == 9) {
            newtickets = newtickets.filter(function (el) {
              return [2, 3, 4, 7].indexOf(Number(el.estatus)) !== -1
            })
          } else if (this.estatusFiltro != 8) {
            newtickets = newtickets.filter(el => el.estatus == this.estatusFiltro)
          }
          if (this.escuela) {
            newtickets = newtickets.filter(el => el.id_unidad_negocio == this.escuela)
          }
          if(this.urgente){
            newtickets = newtickets.filter(el => el.urgenteAdmin == this.urgente)
          }
          if (this.filtroMotivo === '__sin_clasificar__') {
            newtickets = newtickets.filter(el => Number(el.sin_clasificar) === 1)
          } else if (this.filtroMotivo === '__sin__') {
            newtickets = newtickets.filter(el => !el.motivo_concepto)
          } else if (this.filtroMotivo && this.filtroMotivo !== '__todos__') {
            newtickets = newtickets.filter(el => this.motivoAgrupado(el.motivo_concepto) === this.filtroMotivo)
          }
          if (this.filtroPuesto) {
            const puesto = this.filtroPuesto
            newtickets = newtickets.filter(el => (this.textoPuesto(el) || 'Sin puesto') === puesto)
          }
          return newtickets
        }
      },

      ticketsPorResponsable( ){

        let payload = this.tickets.filter( el => el.nombre_jefe == this.responsable && [2,3,4].includes( el.estatus )  )

        let propiedadesUnicas = new Set();
        let arregloSinDuplicados = payload.filter(objeto => !propiedadesUnicas.has(objeto.nombre_completo) && propiedadesUnicas.add(objeto.nombre_completo));

        for( const i in arregloSinDuplicados ){

          const { nombre_completo } = arregloSinDuplicados[i]

          arregloSinDuplicados[i]['Asignados'] = payload.filter( el => el.nombre_completo == nombre_completo ).length

        }

        return arregloSinDuplicados
      },

    },

    watch: {
      conceptosSeleccionados (lista) {
        const ids = (lista || []).map((el) => el.id)
        if (ids.indexOf(this.conceptoDestino) === -1) this.conceptoDestino = null
      },
      area(){
        const puestosArea = (this.area && this.area.puestos) ? this.area.puestos : []
        this.puestos = this.filtrarPuestosPermitidos(puestosArea)
        if (this.puesto && this.isPuestoBloqueado(this.puesto)) {
          this.puesto = null
          this.jefes = []
          this.jefe = null
        }
      },

      puesto(){
        this.jefes = this.puesto ? this.puesto.jefes : []
      },

      usuario(idjefe) {
        if (idjefe) {
          this.cargarTicketsPorJefe(idjefe)
        } else {
          this.initialize()
        }
      },
    },

    async created () {

      this.url = axios.defaults.baseURL + 'evidencia-tickets/'
      this.urlINBI = 'https://lmsinbi.club/evidencia-tickets/'
      this.urlFAST = 'https://lmsfast.club/evidencia-tickets/'
      this.cargar = true
      await this.initialize()
      await this.getAreas()
      if (this.puedeDesbloqueoEmergencia) {
        this.cargarEstadoFinanzas()
      }
    },

    methods: {
      motivoAgrupado (etiqueta) {
        const texto = String(etiqueta || '').trim()
        if (!texto) return ''
        const clave = texto
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
        const grupos = {
          'consulta de chequeos': 'Ajuste de reloj',
          'consulta de reloj': 'Ajuste de reloj',
          'reloj checador': 'Ajuste de reloj',
          'reloj checador no funciona': 'Ajuste de reloj',
          'chequeo incorrecto': 'Ajuste de reloj',
          'correccion de chequeo': 'Ajuste de reloj',
          'justificacion de ausencia': 'Solicitud de ausencia',
          'justificar ausencia': 'Solicitud de ausencia',
        }
        return grupos[clave] || texto
      },

      async cargarEstadoFinanzas () {
        try {
          const response = await this.$http.get('finanzas.bloqueo-validacion.estado')
          const data = response.data || {}
          this.estadoFinanzas = {
            pendientes: Number(data.pendientes) || 0,
            desbloqueo_emergencia: !!data.desbloqueo_emergencia,
            bloqueado: !!data.bloqueado,
          }
        } catch (error) {
          // Silencioso
        }
      },

      async toggleDesbloqueoEmergencia () {
        if (!this.puedeDesbloqueoEmergencia || this.cargandoEmergencia) return

        const activar = !this.estadoFinanzas.desbloqueo_emergencia
        const confirmar = window.confirm(
          activar
            ? '¿Activar desbloqueo de emergencia para admin_finanzas (usuario 28)?'
            : '¿Reactivar el bloqueo por validación de ingresos?'
        )
        if (!confirmar) return

        this.cargandoEmergencia = true
        try {
          const response = await this.$http.post(
            'finanzas.bloqueo-validacion.desbloqueo-emergencia',
            {
              activo: activar ? 1 : 0,
              motivo: activar
                ? 'Desbloqueo de emergencia desde Tickets'
                : 'Reactivación de bloqueo desde Tickets',
            }
          )
          const data = (response.data && response.data.data) || response.data || {}
          this.estadoFinanzas = {
            pendientes: Number(data.pendientes) || 0,
            desbloqueo_emergencia: !!data.desbloqueo_emergencia,
            bloqueado: !!data.bloqueado,
          }
          this.validarSuccess(
            activar
              ? 'Desbloqueo de emergencia activado'
              : 'Bloqueo reactivado'
          )
        } catch (error) {
          let msg = 'No se pudo actualizar el desbloqueo de emergencia'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        } finally {
          this.cargandoEmergencia = false
        }
      },

      normalizarTexto (value) {
        return (value || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
      },

      getEtiquetaPuesto (puesto) {
        return typeof puesto === 'string'
          ? puesto
          : ((puesto && puesto.puesto) || '')
      },

      esAuxiliarRH (puesto) {
        const nombrePuesto = this.normalizarTexto(this.getEtiquetaPuesto(puesto))
        if (/auxiliar.*recursos humanos/.test(nombrePuesto)) return true

        const puestoComoJson = this.normalizarTexto(JSON.stringify(puesto || {}))
        return puestoComoJson.includes('auxiliar') && puestoComoJson.includes('recursos humanos')
      },

      isPuestoBloqueado (puesto) {
        return !this.puedeSeleccionarAuxiliarRH && this.esAuxiliarRH(puesto)
      },

      filtrarPuestosPermitidos (puestos) {
        const lista = Array.isArray(puestos) ? puestos : []
        if (this.puedeSeleccionarAuxiliarRH) return lista
        return lista.filter((puesto) => !this.esAuxiliarRH(puesto))
      },

      getAreas () {
        this.cargar = true
        this.$http.get('departamentos.tickets').then(response=>{
          this.areas = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      formatearFechaRespuestaAsignado (fecha) {
        if (fecha == null || String(fecha).trim() === '') {
          return 'Sin respuesta'
        }

        const fechaRespuesta = moment(fecha)
        if (!fechaRespuesta.isValid() || fechaRespuesta.format('YYYY-MM-DD HH:mm:ss') === '2024-03-04 15:31:27') {
          return 'Sin respuesta'
        }

        return fechaRespuesta.format('DD/MM/YYYY HH:mm:ss')
      },

      /**
       * Texto columna "Resuelto en": tiempo desde asignación hasta ahora (abiertos) o hasta cierre (cerrados).
       * Evita fechas inválidas/null (antes producían ~20.000 días al comparar con epoch).
       */
      textoResueltoEn (ticket) {
        const msegMinuto = 1000 * 60
        const msegHora = msegMinuto * 60
        const msegDia = msegHora * 24

        const duracionMs = (inicio, fin) => {
          const a = inicio instanceof Date ? inicio : new Date(inicio)
          const b = fin instanceof Date ? fin : new Date(fin)
          if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null
          const ms = b.getTime() - a.getTime()
          if (ms < 0) return null
          let tiempo = ms
          const dias = Math.floor(tiempo / msegDia)
          tiempo -= dias * msegDia
          const horas = Math.floor(tiempo / msegHora)
          tiempo -= horas * msegHora
          const minutos = Math.floor(tiempo / msegMinuto)
          return dias + ' días, ' + horas + ' horas, y ' + minutos + ' minutos'
        }

        if (ticket.estatus === 1) {
          return 'El ticket aun no ha sido asignado'
        }

        const fa = ticket.fecha_asignado
        if (fa == null || String(fa).trim() === '') {
          return 'Sin fecha de asignación'
        }

        if ([2, 3, 4, 5, 7].includes(ticket.estatus)) {
          const t = duracionMs(fa, new Date())
          return t || '—'
        }

        if (ticket.estatus === 6) {
          const fc = ticket.fecha_cierre
          if (fc == null || String(fc).trim() === '') {
            return 'Sin fecha de cierre'
          }
          const t = duracionMs(fa, fc)
          return t || '—'
        }

        return '—'
      },

      initialize () {
        if (this.usuario) {
          return this.cargarTicketsPorJefe(this.usuario)
        }
        this.cargar = true
        this.tickets = []
        this.$http.get('tickets.all', { params: { sinEvidencias: 1 } }).then(response=>{

          let list = Array.isArray(response.data) ? response.data : []

          this.longitud = list.length

          if ([161, 382, 626].includes(this.getdatosUsuarioERPERP.iderp)) {
            list = list.filter((el) => el.id_unidad_negocio == this.getEscuela)
          }

          for (let i = 0; i < list.length; i++) {
            list[i].fecha_asignacion = this.textoResueltoEn(list[i])
            list[i].fecha_respuesta_asignado_texto = this.formatearFechaRespuestaAsignado(list[i].fecha_respuesta_asignado)
          }

          this.tickets = list

          this.getUsuarios(this.tickets)
          this.cargar = false

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      /**
       * Consulta tickets de un jefe de área directo a BD (idjefe_area),
       * sin el tope de 6 meses de tickets.all — alinea con el reporte.
       */
      cargarTicketsPorJefe (idjefe_area) {
        if (!idjefe_area) return
        this.cargar = true
        this.cargandoJefe = true
        this.tickets = []
        this.$http.get(`tickets.por.jefe/${idjefe_area}`, { params: { sinEvidencias: 1 } }).then((response) => {
          let list = Array.isArray(response.data) ? response.data : []

          if ([161, 382, 626].includes(this.getdatosUsuarioERPERP.iderp)) {
            list = list.filter((el) => el.id_unidad_negocio == this.getEscuela)
          }

          for (let i = 0; i < list.length; i++) {
            list[i].fecha_asignacion = this.textoResueltoEn(list[i])
            list[i].fecha_respuesta_asignado_texto = this.formatearFechaRespuestaAsignado(list[i].fecha_respuesta_asignado)
          }

          this.tickets = list
          this.longitud = list.length
        }).catch((error) => {
          const msg = (error.response && error.response.data && error.response.data.message)
            || error.message
            || 'Error al consultar tickets del jefe'
          this.validarError(msg)
        }).finally(() => {
          this.cargar = false
          this.cargandoJefe = false
        })
      },

      verMotivo (value) {
        this.ticket = { ...value, evidencias: Array.isArray(value.evidencias) ? [...value.evidencias] : [] }
        this.dialog = true
        const sinEvidencias = !value.evidencias || value.evidencias.length === 0
        if (sinEvidencias) {
          this.cargarEvidencias = true
          this.$http.get(`tickets.evidencias/${value.idticket}`).then((r) => {
            const ev = Array.isArray(r.data) ? r.data : []
            this.ticket = { ...this.ticket, evidencias: ev }
          }).catch(() => {}).finally(() => {
            this.cargarEvidencias = false
          })
        }
      },

      verReasignar (value) {
        this.ticket = value
        this.area = null
        this.puesto = null
        this.jefe = null
        this.firstHistorial = {}
        this.lastHistorial = {}
        this.cargar = true

        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then((response) => {
          const historialTicket = Array.isArray(response.data.HistorialTicket) ? response.data.HistorialTicket : []
          this.firstHistorial = historialTicket[0] || {}
          this.lastHistorial = historialTicket[historialTicket.length - 1] || {}
          this.dialogReasignar = true
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      save () {
        this.ticket.id_area     = this.puesto.idpuesto
        this.ticket.idjefe_area = this.jefe.id_usuario
        this.ticket.estatus     = 2

        this.$http.put('tickets.update.asignacion/'+this.ticket.idticket, this.ticket).then(response=>{
          this.dialog = false
          this.jefe   = null
          this.puesto = null
          this.area   = null
          this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      reasignar() {
        if(!this.area || !this.puesto || !this.jefe){
          this.validarError( 'Datos vacios' )
          return
        }

        if (this.isPuestoBloqueado(this.puesto)) {
          this.validarError('No tienes permiso para seleccionar Auxiliar de recursos humanos')
          return
        }

        if (!this.lastHistorial || !this.lastHistorial.idhistorial_ticket) {
          this.validarError('No se encontró historial del ticket')
          return
        }

        const payload = {
          ...this.ticket,
          idhistorial_ticket: this.lastHistorial.idhistorial_ticket,
          id_area_viejo: this.ticket.id_area,
          idjefe_area_viejo: this.ticket.idjefe_area,
          id_area: this.puesto.idpuesto,
          idjefe_area: this.jefe.id_usuario,
          estatus: 2,
          idauxi_area: 0,
        }

        this.cargar = true
        this.$http.put('tickets.update.asignacion/'+this.ticket.idticket, payload).then(response=>{
          this.dialogReasignar = false
          this.area = null
          this.puesto = null
          this.jefe = null
          this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getColor (estatus) {
        if (estatus == 3) return 'red'
        else if (estatus == 1) return 'orange'
        else if (estatus == 2) return 'blue'
      },

      colorServicio (texto) {
        const t = String(texto || '').toLowerCase()
        if (t.indexOf('electric') !== -1) return 'amber darken-2'
        if (t.indexOf('plomer') !== -1) return 'blue'
        if (t.indexOf('aire') !== -1 || t.indexOf('clima') !== -1) return 'cyan darken-2'
        if (t.indexOf('pintur') !== -1) return 'purple'
        if (t.indexOf('cerraj') !== -1) return 'brown'
        if (t.indexOf('carpint') !== -1) return 'deep-orange'
        if (t.indexOf('limpie') !== -1) return 'teal'
        if (t.indexOf('herrer') !== -1) return 'blue-grey'
        if (t.indexOf('vidri') !== -1) return 'light-blue darken-3'
        if (t.indexOf('jardin') !== -1) return 'green darken-1'
        if (t.indexOf('alba') !== -1) return 'grey darken-1'
        if (t.indexOf('fumig') !== -1) return 'lime darken-3'
        if (t.indexOf('equipo') !== -1) return 'indigo'
        return 'orange darken-2'
      },

      itemRowBackground: function (item) {
        return item.urgenteAdmin ? 'style-2' : item.urgente ? 'style-1' : ''
      },

      puedeVerHistorial(item) {
        if (!item) return false
        if (item.idjefe_area === 966) {
          const iderp = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
          return iderp != null && [1, 334, 966].includes(iderp)
        }
        return true
      },

      textoPuesto (item) {
        if (!item) return ''
        if (Number(item.tipousuario) !== 0) return 'alumno'
        return item.puesto_usuario || ''
      },

      cargarNotas () {
        if (!this.ticket || !this.ticket.idticket) return
        this.$http.get('tickets.notas/' + this.ticket.idticket).then(response => {
          this.mensajes = Array.isArray(response.data) ? response.data : []
        }).catch(error => {
          this.validarError(error.response.data.message)
        })
      },

      enviarMensaje () {
        const nota = String(this.mensajeRechazo || '').trim()
        if (!nota) {
          this.validarErrorDirecto('Ingresa una nota')
          return
        }
        if (!this.ticket || !this.ticket.idticket) return
        this.cargar = true
        const payload = {
          idticket: this.ticket.idticket,
          id_usuario: this.getdatosUsuarioERPERP.iderp,
          nota: nota,
        }
        this.$http.post('tickets.nota', payload).then(() => {
          this.mensajeRechazo = ''
          this.cargarNotas()
        }).catch(error => {
          this.validarError(error.response.data.message)
        }).finally(() => { this.cargar = false })
      },

      historialTicket(value){
        if (!this.puedeVerHistorial(value)) {
          this.validarErrorDirecto('No tienes permiso para ver el historial de este ticket')
          return
        }
        this.ticket = value
        this.historial = []
        this.alumnos = []
        this.mensajes = []
        this.mensajeRechazo = ''
        if (value.tipousuario) {
          //si es alumno
          if (value.id_unidad_negocio == 1) {
            this.urlUser = 'https://lmsinbi.club/evidencia-tickets/'
          } else {
            this.urlUser = 'https://lmsfast.club/evidencia-tickets/'
          }
        } else {
          //si no es alumno
          if(value.movil){
            //viene de la plataforma movil
            if (value.id_unidad_negocio == 1) {
              this.urlUser = 'https://lmsinbi.club/evidencia-tickets/'
              } else {
                this.urlUser = 'https://lmsfast.club/evidencia-tickets/'
              }
          } else {
            //no viene de la plataforma movil
            this.urlUser = axios.defaults.baseURL + 'evidencia-tickets/'
          }
        }
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(response=>{
          this.alumnos = Array.isArray(response.data.alumnos) ? response.data.alumnos : []
          this.mensajes = Array.isArray(response.data.notas) ? response.data.notas : []
          for(const i in response.data.HistorialTicket){
            response.data.HistorialTicket[i].fecha = moment(response.data.HistorialTicket[i].fecha).format('MMMM Do YYYY, h:mm:ss a');
            response.data.HistorialTicket[i].fecharespuesta = moment(response.data.HistorialTicket[i].fecharespuesta).format('MMMM Do YYYY, h:mm:ss a');
            //esta es la fecha y hora en la que se comenzo el registro de respuestas
            if(response.data.HistorialTicket[i].fecharespuesta == 'marzo 4º 2024, 3:31:27 pm'){
              response.data.HistorialTicket[i].fecharespuesta = ''
            }
            this.historial.push(response.data.HistorialTicket[i])
          }
          this.dialogHistorial = true
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
        this.ver = false
      },

      abrirRechazar( ){
        this.historial = []
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(response=>{
          for(const i in response.data.HistorialTicket){
            response.data.HistorialTicket[i].fecha = moment(response.data.HistorialTicket[i].fecha).format('MMMM Do YYYY, h:mm:ss a');
            response.data.HistorialTicket[i].fecharespuesta = moment(response.data.HistorialTicket[i].fecharespuesta).format('MMMM Do YYYY, h:mm:ss a');
            //esta es la fecha y hora en la que se comenzo el registro de respuestas
            if(response.data.HistorialTicket[i].fecharespuesta == 'marzo 4º 2024, 3:31:27 pm'){
              response.data.HistorialTicket[i].fecharespuesta = ''
            }
            this.historial.push(response.data.HistorialTicket[i])
          }
          this.dialogResponder = true
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
        this.ver = false
      },

      exportar(){

        let data = this.filterTickets.map(({ idticket, estatus, motivo, plantel, nombre_jefe, nombre_auxiliar, fecha_apertura, fecha_respuesta_asignado_texto }) => ({ idticket, estatus, motivo, plantel, nombre_jefe, nombre_auxiliar, fecha_apertura, fecha_respuesta_asignado: fecha_respuesta_asignado_texto }));

        for( const i in data ){
          const { estatus } = data[i]

          switch( estatus ){

            case 1:
              data[i].estatus = "Abierto"
            break; 

            case 2:
              data[i].estatus = "Asignado"
            break; 

            case 3:
              data[i].estatus = "Pendiente"
            break; 

            case 4:
              data[i].estatus = "Revisión"
            break; 

            case 5:
              data[i].estatus = "Respondido"
            break; 

            case 6:
              data[i].estatus = "Cerrado"
            break; 

            case 7:
              data[i].estatus = "Rechazado"
            break; 

          }
        }

        this.exportExcel( data, 'tickets_list')
      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`tickets.subir.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },

      async saveRespuesta (respuestas) {
        let fotos = []
        if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.data
          }
        var payload = {
          idhistorial_ticket : respuestas.idhistorial_ticket,
          motivo             : this.ticket.motivo,
          respuestaauxi      : this.respuesta,
          respuesta          : this.respuesta,
          idticket           : this.ticket.idticket,
          estatus            : 0,
          fotos,
          idauxi_area:        this.lastHistorial.idauxi_area,
          idjefe_area:        this.getdatosUsuarioERPERP.id_usuario,
        }
        var estatus = { estatus: 5 }

        this.$http.put('historial_tickets.update/' + respuestas.idhistorial_ticket, payload).then(response=>{
          this.$http.put('tickets.update.estatus/' + this.ticket.idticket,estatus).then(response=>{
            this.mensaje         = ''
            this.respuesta       = ''
            this.dialog          = false
            this.dialogRechazo   = false
            this.dialogResponder = false
            this.vistaPrevias = []
            this.initialize()
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios (value) {
        this.$http.get('usuarios.all.erp').then(response=>{
          this.usuariosTickets = response.data
        }).catch(error=>{console.log(error)})
      },

      updateVisorRh( item ){
        this.cargar = true
        this.$http.post('tickets.update.visorrh', item).then(response=>{
          this.cargar = false
          this.validarSuccess( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      updateUrgente( item ){
        this.cargar = true
        this.$http.post('tickets.update.urgente', item).then(response=>{
          this.cargar = false
          this.validarSuccess( response.data.message )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      nombreDepartamento (id) {
        const lista = this.departamentosCatalogo || []
        for (let i = 0; i < lista.length; i++) {
          if (Number(lista[i].iddepartamento) === Number(id)) return lista[i].departamento
        }
        return ''
      },

      recortarInstruccion (texto) {
        const limpio = String(texto || '').replace(/\s+/g, ' ').trim()
        if (limpio.length <= 80) return limpio
        return limpio.slice(0, 80) + '...'
      },

      editarConcepto (item) {
        this.conceptoEdicion = {
          id: item.id,
          etiqueta: item.etiqueta,
          iddepartamento: item.iddepartamento,
          instruccion: item.instruccion || '',
        }
        this.dialogEditarConcepto = true
      },

      guardarConcepto () {
        if (!this.conceptoEdicion.iddepartamento) {
          return this.validarErrorDirecto('Elige un departamento')
        }
        this.guardandoConcepto = true
        this.$http.post('tickets.conceptos.asignacion', {
          id: this.conceptoEdicion.id,
          iddepartamento: this.conceptoEdicion.iddepartamento,
          instruccion: this.conceptoEdicion.instruccion,
        }).then(() => {
          this.dialogEditarConcepto = false
          this.validarSuccess('Motivo actualizado')
          this.abrirCatalogoConceptos()
        }).catch((error) => {
          let msg = 'No se pudo guardar el motivo'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        }).finally(() => { this.guardandoConcepto = false })
      },

      abrirCatalogoConceptos () {
        this.dialogCatalogoConceptos = true
        this.conceptosSeleccionados = []
        this.conceptoDestino = null
        this.cargandoCatalogo = true
        this.$http.get('departamentos.tickets').then((response) => {
          this.departamentosCatalogo = Array.isArray(response.data) ? response.data : []
        }).catch(() => { this.departamentosCatalogo = [] })
        this.$http.get('tickets.conceptos').then((response) => {
          this.conceptosCatalogo = Array.isArray(response.data) ? response.data : []
        }).catch((error) => {
          let msg = 'No se pudo cargar el catálogo'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        }).finally(() => { this.cargandoCatalogo = false })
      },

      fusionarConceptos () {
        const seleccion = this.conceptosSeleccionados || []
        const ids = seleccion
          .map((el) => el.id)
          .filter((id) => id !== this.conceptoDestino)
        if (!this.conceptoDestino || !ids.length) {
          return this.validarErrorDirecto('Elige las etiquetas a fusionar y cuál se conserva')
        }
        this.fusionandoCatalogo = true
        this.$http.post('tickets.conceptos.fusionar', {
          ids,
          id_destino: this.conceptoDestino,
        }).then((response) => {
          this.validarSuccess(response.data.message)
          this.conceptosSeleccionados = []
          this.conceptoDestino = null
          this.abrirCatalogoConceptos()
          this.initialize()
        }).catch((error) => {
          let msg = 'No se pudieron fusionar las etiquetas'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        }).finally(() => { this.fusionandoCatalogo = false })
      },

      getReporteTicketsUsuario(){
        this.cargar  = true
        this.reporte = []
        this.reporteModo = 'usuario'
        this.$http.get('tickets.reporte.usuario').then(response=>{
          this.reporte = response.data.filter( el => el.Asignados > 0 || el.Pendiente > 0 || el.Revisión > 0 || el.Rechazados > 0 )

          for( const i in this.reporte){

            const { Asignados , Pendiente , Revisión , Rechazados } = this.reporte[i]

            this.reporte[i]['Total_contestar'] = Asignados + Pendiente + Revisión + Rechazados

          }

          console.log(this.reporte)
          this.dialogReporte = true
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getReporteTicketsMotivo(){
        this.cargar = true
        this.reporte = []
        this.reporteModo = 'motivo'
        this.$http.get('tickets.reporte.motivo').then(response=>{
          this.reporte = response.data.filter( el => el.Asignados > 0 || el.Pendiente > 0 || el.Revisión > 0 || el.Rechazados > 0 )

          for( const i in this.reporte){
            const { Asignados , Pendiente , Revisión , Rechazados } = this.reporte[i]
            this.reporte[i]['Total_contestar'] = Asignados + Pendiente + Revisión + Rechazados
          }

          this.dialogReporte = true
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getReportePorResponsable(){
        this.cargar  = true
        this.reporte = []
        this.$http.get('tickets.reporte.usuario').then(response=>{
          this.reporte = response.data.filter( el => el.Asignados > 0 || el.Pendiente > 0 || el.Revisión > 0 || el.Rechazados > 0 )
          this.dialogResponsable = true
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      verImagen( imagen, es_solucion ){
        this.imagen       = imagen
        this.es_solucion = es_solucion
        this.dialogImagen = true
      },
      closeImagen(){
          this.dialogImagen = false
      },
    },
  }
</script>
<style>
  .tickets-listado {
    min-width: 0 !important;
    max-width: 100%;
    overflow: hidden;
  }

  .tickets-listado > .v-card {
    max-width: 100%;
    overflow: hidden;
  }

  .tickets-toolbar {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .tickets-tabla-acciones {
    display: block;
    min-width: 0;
    max-width: 100%;
  }

  .tickets-tabla-acciones > .row {
    min-width: 0;
    max-width: 100%;
  }

  .tickets-tabla-scroll {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: auto;
  }

  .tickets-tabla-scroll .v-data-table {
    width: 100%;
    max-width: 100%;
  }

  .tickets-tabla-scroll .v-data-table__wrapper {
    overflow-x: auto !important;
    overflow-y: auto !important;
    max-width: 100% !important;
  }

  .tickets-tabla-scroll .v-data-table table {
    width: max-content;
    min-width: 100%;
  }

  .tickets-tabla-scroll .v-data-table th,
  .tickets-tabla-scroll .v-data-table td {
    white-space: nowrap;
  }

  .v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button{
    display: none;
  }

  .v-data-table__wrapper::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .mensajeIzq{
    white-space: pre-line;
    background-color: rgb(238, 235, 235);
    border-radius: 0px 10px 10px 10px;
  }
  .mensajeDer{
    white-space: pre-line;
    background-color: rgb(193, 231, 243);
    border-radius: 10px 0px 10px 10px;
  }

  .style-1 {
    background-color: rgb(253, 169, 169);
  }

  .style-1:hover {
    background-color: rgb(238, 131, 131) !important;
  }

  .style-2 {
    background-color: #EB8DE3;
  }

  .style-2:hover {
    background-color: #EB8DE3 !important;
  }

</style>